<template>
    <div>
        <div class="title">
            {{ name }}
        </div>
        <br>
        <div class="body-2">
            {{ vicinity }}
        </div>
    </div>
</template>

<script>

export default {
    name: 'InfoWindow',
    data() {
        return {};
    },
    props: {
        name: String,
        vicinity: String,
    }
}
</script>
